import { ButtonClean, CurrencyInput, Fieldset, PriceString, Tooltip } from '@fourthwall/components';
import React, { useEffect, useMemo } from 'react';
import { routing } from '@utils/routing';
import { isPaidTier } from '../../../../utils';
import { useTierContext } from '../../hooks/useTierContext';
import { FormFields } from '../../providers/TierProvider/types';
export const Price = () => {
    const { tier, isCreatingNewTier, form, annualDiscount } = useTierContext();
    const membersCount = tier?.statistics.membersCount;
    // Disable discount and automatical international pricing conversion when price is 0 (free tier)
    useEffect(() => {
        if (form.dirty && parseFloat(form.values.price) === 0) {
            form.setFieldValue(FormFields.discount, false);
            form.setFieldValue(FormFields.convertInternationalPricing, true);
        }
    }, [form.values.price]);
    const renderSuggestion = () => {
        if (form.values.price && parseFloat(form.values.price) === 0) {
            return 'All free accounts will be automatically assigned to this free tier.';
        }
        if (!annualDiscount) {
            return (React.createElement(ButtonClean, { withUnderline: true, appearance: "secondary", type: "button", label: "Offer annual memberships", to: routing.memberships.settings.general }));
        }
        if (!form.values.price)
            return undefined;
        const yearPrice = form.values.price
            ? parseFloat(form.values.price) * 12 -
                parseFloat(form.values.price) * 12 * (annualDiscount / 100)
            : 0;
        return (React.createElement(React.Fragment, null,
            React.createElement(PriceString, { value: yearPrice }),
            " price per year (",
            React.createElement(ButtonClean, { withUnderline: true, appearance: "secondary", type: "button", label: `${annualDiscount}% discount`, to: routing.memberships.settings.general }),
            ")"));
    };
    const disabled = useMemo(() => {
        if (isCreatingNewTier)
            return false;
        if (membersCount)
            return membersCount > 0;
        if (tier)
            return !isPaidTier(tier);
    }, [tier, membersCount, isCreatingNewTier]);
    if (tier && isPaidTier(tier) && membersCount && membersCount > 0) {
        return (React.createElement(Fieldset.Row, null,
            React.createElement(Fieldset.Item, null,
                React.createElement(Tooltip, { placement: "top", reference: React.createElement(CurrencyInput, { label: "Price per month", suggestion: renderSuggestion(), disabled: true, ...form.getFieldProps(FormFields.price) }) }, "Tier price in this currency cannot be changed when there are active members."))));
    }
    return (React.createElement(Fieldset.Row, null,
        React.createElement(Fieldset.Item, null,
            React.createElement(CurrencyInput, { label: "Price per month", suggestion: renderSuggestion(), disabled: disabled, ...form.getFieldProps(FormFields.price) }))));
};
